<template>
  <validation-observer ref="archiveCardObserver" novalidate tag="form">
    <div class="row">
      <div class="col-md-12 text-bold bold mb-3">
        <i class=" fa fa-folder-open color-orange" />
        Archivar
      </div>
      <div class="col-md-12 mt-2">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="model.comment"
            class=""
            custom-error-msg="El comentario es requerido."
            :error="errors[0]"
            label="Comentario:"
            :maxlength="500"
            :rows="4"
            show-char-count
          />
        </validation-provider>
      </div>

      <div class="col-md-12 text-right mt-3 pt-1">
        <action-button
          i="fas fa-times-circle"
          variant="outline-danger mr-3"
          @click="$emit('on-cancel')"
        >
          Cancelar
        </action-button>
        <action-button i="fas fa-save" variant="success" @click="submit">
          Guardar
        </action-button>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import alertMixin from '@/mixins/alert.mixin';
import { putArchived } from '@/modules/shared/cardHandling.api';
export default {
  name: 'ArchiveCard',
  components: {
    CustomTextArea,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      default: 0,
      require: true,
    },
  },
  data: () => ({
    model: {
      comment: '',
    },
  }),
  methods: {
    async submit() {
      this.model.becaCardId = this.id;
      const isValid = await this.$refs.archiveCardObserver.validate();
      if (isValid) {
        let payload = {
          comment: this.model.comment,
          becaCardId: this.model.becaCardId,
        };
        putArchived(payload)
          .then(() => {
            this.ShowToast(
              'Confirmación',
              'La tarjeta ha sido archivada exitosamente.',
              'success'
            );
            this.$emit('on-saved');
          })
          .catch((err) => {
            if (err && err.response && err.response.data) {
              this.ShowToast('Error', err.response.data.message, 'error');
            } else {
              this.ShowToast('Error', err.message, 'error');
            }
          });
      }
    },
  },
};
</script>
<style scoped lang="scss"></style>
